/* eslint-disable jsx-a11y/label-has-for */
/* eslint-disable jsx-a11y/label-has-associated-control */
import React from 'react'
import { Form } from 'semantic-ui-react'

export default class GoToField extends React.PureComponent {
  render() {
    const { value, onChange } = this.props

    const options = [
      { key: 1, text: 'Company', value: 'COMPANY' },
      { key: 2, text: 'Driver', value: 'DRIVER' },
      { key: 3, text: 'Merchant', value: 'MERCHANT' },
    ]

    return (
      <Form.Select
        required
        fluid
        label="Go To"
        options={options}
        placeholder="Company/Driver/Merchant"
        onChange={(e, data) => onChange('go_to', data.value)}
        value={value}
      />
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/restaurants/fields/feeGoToField.js